module.exports = __webpack_public_path__ + "static/img/chejia_car_1.4ad59ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/Homepage/chejia_car_1.png
// module id = jt3P
// module chunks = 19